import { defineComponent, h } from 'vue';
import { QToolbar, QToolbarTitle, QSpace, QBtn, QIcon, QCard, QCardSection, QCardActions, QInput, QDialog, QList, QItem, QItemSection, QItemLabel, QMenu, QTabPanels, QTabPanel, QImg, QSeparator } from 'quasar';
import BaseComponent from "./BaseComponentMixin.jsx";
import utils from "../../Shared/utils.jsx";
import EventBus from "../event-bus.js";
import api from '@/Services/api';
import "./css/Dash.css";
import ResponsiveDash from "./vuecontrols/responsiveDash.vue";
//import AdvancedReports from './AdvancedReports.vue';
//import AdvancedHistory from './AdvancedHistory.vue';
import BasicForm from './BasicForm.jsx';
import DynamicUserControl from './UserControl.jsx';
import BrokenImage from '../../Assets/BrokenImage.svg';

import TranslationContainer from './TranslationContainer.jsx';
import CardBrowser from './CardBrowser.jsx';

//const cloneDeep = require('lodash.clonedeep')
import cloneDeep from 'lodash/cloneDeep';

const busyIcon = defineComponent({
    components: { QIcon },
    render() {
        return (
            <QIcon
                name="mdi-cloud-download"
                size="sm"
                color="white"
                style={{ visibility: utils.global_variables.api_busy_indicator ? 'visible' : 'hidden' }}
            />
        );
    }
});

export default defineComponent({
    name: 'dash',
    mixins: [BaseComponent],
    components: {
        QToolbar, QToolbarTitle, QSpace, QBtn, QIcon, QCard, QCardSection, QCardActions, QInput, QDialog, QList, QItem, QItemSection, QItemLabel, QMenu, QTabPanels, QTabPanel, QImg, QSeparator,
        ResponsiveDash,
        busyIcon,
        //AdvancedReports,
        //AdvancedHistory,
        BasicForm,
        DynamicUserControl,
        TranslationContainer,
        CardBrowser,
    },
    data: function() {
        return {
            iseditable: null,
            delay_expn: 0,
            dashboard: 0,
            editing: false,
            selected_dashboard: -1,
            layout: {
                breakpoint: "xl",
                numberOfCols: 24,
                compact: true,
                items: [],
            },
            picker: null,
            pickervisible: false,
            istemplate: null,
            templateid: null,
            newproperties: {},
            //menuActions: null,
            dash_tabs: [],
            dash_loading: true,
            dialog_width: 860,
            dashboardMenuOpen: false,
            // ControlURL -> true when that card's UserControl declares a DashboardPrompt, so the
            // configure (cog) button is only offered on cards that have something to configure.
            configurableCards: {},
            // item id -> revision; bumped when a card's configuration changes so it remounts
            cardRevisions: {},
            // bumped for every prompt opened, so each prompt's form is built fresh against its own model
            promptSeq: 0,
        };
    },
    //Mounted Replaced with preRenderComplete
    computed: {
        style() {
            return {
                "display": "flex",
                "flex-direction": "column",
                ...this.sizeStyle,
                xborder: "1px solid red"
            };
        },
        isEditableComputed: function () {
            try {

                if (this.iseditable === null && this.controlData.EditableExpression !== null)
                    this.iseditable = utils.compile(this, this.controlData.EditableExpression);

                let iseditable = utils.evaluate(this.iseditable, this) || false;
                return iseditable;
            } catch (e) {
                utils.warn("Editable Expression could not evaluate expression: " + this.controlData.EditableExpression + "; " + e);
                return "";
            }
        },
        isTemplateComputed: function () {
            try {
                if (this.istemplate === null && this.controlData.IsTemplate !== null)
                    this.istemplate = utils.compile(this, this.controlData.IsTemplate);

                let istemplate = utils.evaluate(this.istemplate, this) || false;
                return istemplate;
            } catch (e) {
                utils.warn("Template Expression could not evaluate expression: " + this.controlData.IsTemplate + "; " + e);
                return "";
            }
        }
    },
    created() {
        if (this.controlData.RefreshFrequency)
            this.delay_expn = utils.compileExpression(this, this.controlData.RefreshFrequency);
        
        if(this.isTemplateComputed && this.controlData.TemplateId)
            this.templateid = utils.compile(this, this.controlData.TemplateId)
        
    },
    unmounted() {
        if (this.interval) clearInterval(this.interval);
    },
    methods: {
        async runPassedInActions(theaction) {
            let actions = [];
            actions.push(theaction);
            await utils.executeAndCompileAllActions(actions, this, this);
        },
        async preRenderComplete() {
            this.finishRenderHandler(this);
            await this.Refresh();
            this.dash_loading = false;

            const delay = this.delay_expn ? utils.evaluate(this.delay_expn, this) : 0;

            if (delay)
                this.interval = setInterval(() => {
                    EventBus.$emit("RefreshWidgets");
                }, delay * 1000);

            const lastSelectedDashboard = this.System.LocalStorage(`Dashboard_${this.controlData.Name || 'undefined'}`);
            if(lastSelectedDashboard) {
                this.dashboard = this.dash_tabs.findIndex(dt => dt.ID == lastSelectedDashboard);
                if(this.dashboard == -1) {
                    this.dashboard = 0;
                    this.System.LocalStorage(`Dashboard_${this.controlData.Name || 'undefined'}`, this.dash_tabs[0]?.ID);

                }
            }
        },
        async Refresh() {
            try {
                let data;
                const templateId = this.templateid ? utils.evaluate(this.templateid, this) : 0;
                if(this.isTemplateComputed) {
                    if(templateId) {
                        data = await utils.api.get(`Apps/Platform/Schema/Data/v1/DashboardTemplate?ID=${templateId}`, false, false);
                        data = [data];
                    }
                    else 
                        data = [{
                            Name: "{Template Name}",
                            Layout: {
                                breakpoint: "xl",
                                numberOfCols: 24,
                                compact: true,
                                items: [],
                            },
                        }];
                } else {
                    data = await utils.api.request('POST', `Apps/Data/v1/UserDashboards/ListAllMyDashboards?AllowPersonalDashboards=${this.controlData.AllowPersonalDashboards}`, this.controlData.DefaultTemplates, false, true);
                    data = data.Result;
                }

                if (data && data.length > 0) {
                    this.dash_tabs = data
                        .sort((a, b) => a.Order - b.Order)
                        .map(d => ({
                            Title: d.Name,
                            Description: d.Description,
                            ID: d.ID,
                            editing: false,
                            layout: d.Layout,
                            TemplateID: d.TemplateID
                        }));
                }
            }
            catch (e) {
                utils.warn(`Failed to load dashboards (Apps/Data/v1/UserDashboards/ListByID)`, e);
            }
        },
        async cancelTab(t) {
            if(t.ID) {
                this.toggleEditing(t);
                await this.Refresh();
                this.remountConfiguredCards();
            } else {
                this.dash_tabs.pop();
                this.dashboard = this.dash_tabs.length - 1;
                this.System.LocalStorage(`Dashboard_${this.controlData.Name || 'undefined'}`, this.dash_tabs[this.dashboard].ID)

            }
        },
        async saveTab(t) {
            const data = {
                ID: t.ID,
                Name: t.Title,
                Description: t.Description,
                Layout: {
                    breakpoint: t.layout.breakpoint,
                    numberOfCols: t.layout.numberOfCols,
                    compact: t.layout.compact,
                    items: t.layout.items.map(i => ({
                        id: i.id,
                        x: i.x,
                        y: i.y,
                        width: i.width,
                        height: i.height,
                        locked: true,
                        title: i.title,
                        ControlURL: i.ControlURL,
                        ControlData: i.ControlData,
                    })),
                },
                Order: this.dash_tabs.findIndex(a => a.Title == t.Title),
            };
            if(t.TemplateID)
                data.TemplateID = t.TemplateID;

            let res;

            if(this.isTemplateComputed) {
                res = await utils.api.request('POST', 'Apps/Platform/Schema/Data/v1/DashboardTemplate?AutoReplace=true', data);
            } else {
                res = await utils.api.request('POST', 'Apps/Data/v1/UserDashboards/SaveMyDashboard?AutoReplace=true', data);
            }

            if (res.Success) {
                t.ID = res.ID;
                this.toggleEditing(t);
                
                if(this.controlData.SaveActions && this.controlData.SaveActions.length > 0)
                    await utils.executeAndCompileAllActions(this.controlData.SaveActions, null, this);
            }
        },
        async deleteTab(t) {
            this.dialog_width = 400;
            this.picker = (
                <QCard>
                    <QToolbar class="text-white" style="background-color: var(--v-navigation-base); height: 60px; width: 400px">
                        <QToolbarTitle class="title text-white pl-0">
                            <TranslationContainer context={this} value="Delete Dashboard"></TranslationContainer>
                        </QToolbarTitle>
                        <QBtn flat dense color="white" onClick={(e) => this.pickervisible = false}>
                            <QIcon name="mdi-close" />
                        </QBtn>
                    </QToolbar>

                    <QCardSection class="q-mt-sm">
                        <TranslationContainer context={this} value="Are you sure you want to delete?"></TranslationContainer>
                    </QCardSection>

                    <QCardActions class="q-ma-sm" align="right">
                        <QBtn color="primary" no-caps class="c-SentenceCaseButton" onClick={() => this.deleteDashboard(t)}>
                            <TranslationContainer context={this} value="Yes"></TranslationContainer>
                        </QBtn>
                    </QCardActions>
                </QCard>
            );
            this.pickervisible = true;
        },
        async deleteDashboard(t) {
            if (t.ID) {
                if(t.TemplateID)
                    await utils.api.request('POST', `Apps/Data/v1/UserDashboards/UserSoftDeleteTemplateDashboard?AutoReplace=true`, t);
                else
                    await utils.api.request('DELETE', `Apps/Data/v1/UserDashboards?ID=${t.ID}`);
            }
            this.pickervisible = false;
            const idx = this.dash_tabs.findIndex(a => a == t);
            if (idx >= 0)
                this.dash_tabs.splice(idx, 1);

            if (this.dashboard >= this.dash_tabs.length) {
                this.dashboard = this.dash_tabs.length - 1;
                this.System.LocalStorage(`Dashboard_${this.controlData.Name || 'undefined'}`, this.dash_tabs[this.dashboard]?.ID)
            }
            
        },

        addTab(e) {
            const t = {
                Title: this.Translate('Untitled'),
                editing: true,
                layout: {
                    breakpoint: "xl",
                    numberOfCols: 24,
                    compact: true,
                    items: [],
                }
            };

            this.dash_tabs.push(t);

            this.dashboard = this.dash_tabs.length - 1;
            this.System.LocalStorage(`Dashboard_${this.controlData.Name || 'undefined'}`, this.dash_tabs[this.dashboard].ID)
        },
        toggleEditing(t) {
            t.editing = !t.editing;

            if (t.editing)
                this.loadConfigurableCards(t);

            for (let i = 0; i < t.layout.items.length; i++) {
                t.layout.items[i].static = !t.editing;
                //delete t.layout.items[i]["$isEditing"];
            }

            if (!t.editing) {
                // Save layout
                const data = JSON.stringify(t.layout.items);
                this.System.LocalStorage("dash.layout.1", data);
            }
        },

        addWidget(t, cardDefinition, props) {
            let newid = '1';
            if (t.layout.items.length > 0) {
                const id = Math.max(...t.layout.items.map(i => parseInt(i.id)));
                newid = `${id + 1}`;
            }
            
            let x = 0, y = 0;
            let blocked = true;

            // Ensure the width doesn't exceed the total columns to prevent an infinite loop
            const newWidth = Math.min(cardDefinition.Width, t.layout.numberOfCols);
            const newHeight = cardDefinition.Height;

            // Scan across and down looking for an opening
            for (y = 0; ; y++) {
                // Prevent 'x' from pushing the card off the right edge of the grid
                for (x = 0; x <= t.layout.numberOfCols - newWidth; x++) {
                    
                    blocked = t.layout.items.some(i => {
                        // Bounding Box Collision Detection
                        // Checks if the new card area overlaps with an existing item 'i'
                        const overlapX = (i.x < x + newWidth) && ((i.x + i.width) > x);
                        const overlapY = (i.y < y + newHeight) && ((i.y + i.height) > y);
                        
                        return overlapX && overlapY;
                    });

                    // If we found a spot where it's not blocked, break out of the X loop
                    if (!blocked) break;
                }

                // If we found a spot where it's not blocked, break out of the Y loop
                if (!blocked) break;
            }
            
            var newItem = {
                id: newid,
                x: x,
                y: y,
                width: newWidth, // Use our validated width
                height: newHeight,
                locked: false,
                title: cardDefinition.Name,
                ControlURL: cardDefinition.UserControl,
                ControlData: {...cloneDeep(props), FilterId: utils.generateUUID()},
            };

            t.layout.items.push(newItem);
            this.pickervisible = false;
            this.loadConfigurableCards(t);
        },

        // Reopen a placed card's DashboardPrompt, seeded with its current configuration, and
        // write the answers back onto the same card. The card keeps its FilterId, so its saved
        // column and filter state stay with it.
        async configureItem(t, item) {
            const layoutItem = t.layout.items.find((i) => i.id == item.id);
            if (!layoutItem || !layoutItem.ControlURL)
                return;

            const control = await this.loadCardControl(layoutItem.ControlURL);
            const prompt = this.getDashboardPrompt(control);
            if (!prompt)
                return;

            const model = cloneDeep(layoutItem.ControlData || {});
            delete model.FilterId;

            // A prompt field that has become a list since the card was placed still holds a
            // single value; hand the form a list so it can show the current choice.
            Object.keys(prompt.properties || {}).forEach((k) => {
                if (prompt.properties[k] && prompt.properties[k].type === 'array' && model[k] !== undefined && model[k] !== null && !Array.isArray(model[k]))
                    model[k] = [model[k]];

                // A field added to the prompt after this card was placed: its default is for new cards, so
                // show it empty rather than let the form fill in the default and change what the card does.
                // Empty, not null: the form also replaces a null with the default.
                const empty = { boolean: false, string: '', array: [] };
                if (prompt.properties[k] && 'default' in prompt.properties[k] && !(k in model) && prompt.properties[k].type in empty)
                    model[k] = empty[prompt.properties[k].type];
            });

            this.newproperties = model;
            this.dialog_width = 860;
            this.picker = this.promptCard(layoutItem.title || layoutItem.ControlURL, prompt, () => this.updateWidget(t, layoutItem, this.newproperties));
            this.pickervisible = true;
        },

        updateWidget(t, layoutItem, props) {
            const filterId = (layoutItem.ControlData && layoutItem.ControlData.FilterId) || utils.generateUUID();
            layoutItem.ControlData = { ...cloneDeep(props), FilterId: filterId };
            this.cardRevisions[layoutItem.id] = (this.cardRevisions[layoutItem.id] || 0) + 1;
            this.pickervisible = false;
        },

        remountConfiguredCards() {
            Object.keys(this.cardRevisions).forEach((id) => {
                this.cardRevisions[id] = this.cardRevisions[id] + 1;
            });
        },

        async loadCardControl(userControl) {
            let apiRequest = {
                method: 'GET',
                url: `Apps/UIWhole/UserControl/${userControl}`,
                doNotUseWebsocket: true,
                flatten: false,
                cache: false,
            };

            let c = await api.apiRequest(apiRequest);
            let responseControl = c.data?.Result || c.data;
            if (!responseControl) {
                apiRequest.url = `Apps/UIWhole/UserControl/public/${userControl}`;
                c = await api.apiRequest(apiRequest);
                responseControl = c.data?.Result || c.data;
            }
            return responseControl;
        },

        getDashboardPrompt(control) {
            const s = control && control.ControlDataSchema;
            if (s && s.properties && Object.keys(s.properties).length > 0 && s.properties["DashboardPrompt"] && Object.keys(s.properties.DashboardPrompt).length > 0)
                return s.properties.DashboardPrompt;
            return null;
        },

        async loadConfigurableCards(t) {
            const urls = [...new Set((t.layout.items || []).map((i) => i.ControlURL))]
                .filter((u) => u && u != "ReportUnavailable" && this.configurableCards[u] === undefined);

            for (const u of urls) {
                try {
                    this.configurableCards[u] = !!this.getDashboardPrompt(await this.loadCardControl(u));
                }
                catch (e) {
                    this.configurableCards[u] = false;
                }
            }
        },

        isConfigurable(item) {
            return !!(item && item.ControlURL && this.configurableCards[item.ControlURL]);
        },

        promptCard(title, prompt, onOk) {
            // The width goes on the card: QDialog does not size its content, so without it the
            // dialog shrinks to the widest field and the title truncates (CCDEV-16990).
            return (
                <QCard key={`prompt_${++this.promptSeq}`} style={{ width: this.dialog_width + 'px', maxWidth: '90vw' }}>
                    <QToolbar class="text-white" style="background-color: var(--v-navigation-base); height: 60px">
                        <QToolbarTitle class="title text-white pl-0">
                            <TranslationContainer context={this} value={title}></TranslationContainer>
                        </QToolbarTitle>
                        <QSpace />
                        <busyIcon></busyIcon>
                        <QBtn flat dense color="white" onClick={(e) => this.pickervisible = false}>
                            <QIcon name="mdi-close" />
                        </QBtn>
                    </QToolbar>

                    <QCardSection class="q-mt-sm">
                        <BasicForm
                            controlData={{
                                FormType: 'Standard',
                                FormOptions: {
                                    ArrayStart: 'DefaultItem',
                                    DestroyStrategy: 'retain',
                                    NoInput: false,
                                },
                                Model: {
                                    Type: 'Raw',
                                    Definition: this.newproperties,
                                },
                                Schema: {
                                    Type: 'Raw',
                                    Definition: prompt,
                                },
                                Form: {
                                    Type: 'Inline',
                                    Definition: [
                                        {
                                            AllSchemaElements: true
                                        }
                                    ]
                                },
                                FormSize: 'Normal',
                                SizeOptions: {
                                    Width: {
                                        Mode: 'Fill'
                                    },
                                    Height: {
                                        Mode: 'Auto'
                                    }
                                }
                            }}
                        ></BasicForm>
                    </QCardSection>

                    <QCardActions class="q-ma-sm" align="right">
                        <QBtn color="primary" no-caps class="c-SentenceCaseButton" onClick={() => onOk()}>
                            <TranslationContainer context={this} value="OK"></TranslationContainer>
                        </QBtn>
                    </QCardActions>

                </QCard>
            );
        },

        removeItem(t, item) {
            const idx = t.layout.items.findIndex((i) => i.id == item.i);
            if (idx >= 0) t.layout.items.splice(idx, 1);
        },
        browse(t) {
            this.dialog_width = 860;
            this.picker = (
                <CardBrowser
                    confirm={(cardDefinition) => this.confirm(cardDefinition, t)}
                    cancel={this.cancel}
                ></CardBrowser>
            );
            this.pickervisible = true;
        },
        async confirm(cardDefinition, t) {
            this.pickervisible = false;
            
            if(cardDefinition.UserControl) {
                // grab the control, find the schema, present a form to edit the properties
                const responseControl = await this.loadCardControl(cardDefinition.UserControl);

                // Open a dialog with a form to input properties from the schema
                const prompt = this.getDashboardPrompt(responseControl);
                if (prompt) {
                    this.newproperties = {};
                    this.dialog_width = 860;
                    this.picker = this.promptCard(cardDefinition.Name || cardDefinition.UserControl, prompt, () => this.addWidget(t, cardDefinition, this.newproperties));
                    this.pickervisible = true;
                } else {
                    this.addWidget(t, cardDefinition, cardDefinition.Type == "Numeric" ? { Metric : cardDefinition.Metric } : {});
                }
            } else if(cardDefinition.Type == "Aggregate" || cardDefinition.Type == "Detail") {
                var widgetDef = {
                    Width: 11,
                    Height: 7,
                    UserControl: "ReportStudio/DashboardReport",
                    Name: cardDefinition.Name,
                };
                var controlData = {
                    DashboardData: {
                        RefreshInterval: cardDefinition.Status.RefreshInterval || "Never",
                        ReportName: cardDefinition.Name,
                        ReportID: cardDefinition.ID,
                        ReportType: cardDefinition.Type
                    },
                    ReportID: cardDefinition.ID
                }
                this.addWidget(t, widgetDef, controlData)

            }
        },
        cancel() {
            this.pickervisible = false;
        },
        getHeader(h) {
            const header = [];
            if (this.isEditableComputed && !this.dash_tabs[this.dashboard]?.editing) {
                header.push(
                    <QBtn key="edit-dash" flat onClick={() => this.toggleEditing(this.dash_tabs[this.dashboard])}>
                        <QIcon name="mdi-pencil" style="fontSize:larger !important; color:black!important" />
                    </QBtn>
                );
            }

            if (this.controlData.HeaderControls && this.controlData.HeaderControls.length > 0) {
                for (let i = 0; i < this.controlData.HeaderControls.length; i++) {
                    const c = this.controlData.HeaderControls[i];
                    let DynamicControl = utils.getDynamicComponent(h, c);
                    if (!DynamicControl)
                        DynamicControl = 'default-unknown';
        
                    if (!c.$objectId)
                        c.$objectId = utils.generateUUID();
        
                    let id = `${c.$objectId}_${i}`;
        
                    header.push(
                        <DynamicControl
                            onFinishedRender={(reference) => this.finishRenderHandler(reference)}
                            type={c.ControlType}
                            key={id}
                            name={c.ControlData ? (c.ControlData.Name || 'unnamed') : 'unnamed'}
                            root={this.root}
                            parentType="HorizontalStack"
                            controlData={c.ControlData}
                            controlURL={c.ControlURL}
                            controlName={c.Name}
                            accessPermission={c.AccessPermission}
                            cacheControl={c.CacheControl}
                            controlEvents={c.Events}
                        >
                        </DynamicControl>
                    );
                }
                return header;
            }
            
            return header;
        }
    },
    props: {},
    render() {
        if (!this.todisplay || this.dash_loading) return null;

        const tabs = [];
        const window_body = [];

        for (let i = 0; i < this.dash_tabs.length; i++) {
            const t = this.dash_tabs[i];

            let title = t.Title;
            if (t.editing)
            {
                if (!t.static) {
                    title =
                        <div style="display: flex; align-items: center;">
                            <QInput style="width: 300px;" dense outlined class="pt-1 pb-1" modelValue={t.Title} onUpdate:modelValue={(e) => t.Title = e} />
                            {utils.generateTooltip(h, <QBtn flat dense round size="sm" onClick={(e) => this.saveTabTitle(e, t)}><QIcon name="mdi-check" size="sm" /></QBtn>, this.Translate('Save'), 'right')}
                            {utils.generateTooltip(h, <QBtn flat dense round size="sm" onClick={(e) => this.cancelEditTabTitle(e, t)}><QIcon name="mdi-close" size="sm" /></QBtn>, this.Translate('Cancel'), 'right')}
                        </div>;
                }
                else {
                    title =
                        <span>
                            {t.Title}
                            {utils.generateTooltip(h, <QBtn flat dense round size="sm" onClick={(e) => this.editTabTitle(e, t)}><QIcon name="mdi-pencil" size="sm" /></QBtn>, this.Translate('Edit'), 'right')}
                        </span>;
                }
            }
            else if (!t.ID)
                title += ' (Not Saved)';

            const scopedSlots = {
                content: ({ item }) => {
                    if (item.ControlURL == "ReportUnavailable") {
                        return (
                            <div style="align-self:center;">
                                <QImg style="transform: scale(.75)" src={BrokenImage}/>
                                <TranslationContainer context={this} value="This report has been removed"></TranslationContainer>
                                <br />
                                <TranslationContainer context={this} value="from the Card Library"></TranslationContainer>
                            </div>
                        )
                    }
                    else if (item.ControlURL) {
                        return (
                            <DynamicUserControl
                                key={`${item.id}_${this.cardRevisions[item.id] || 0}`}
                                class="c-Dash-Content"
                                style="flex-grow: 1;"
                                onFinishedRender={(reference) => this.finishRenderHandler(reference)}
                                root={this.root}
                                parentType="Dash"
                                isDashboard={true}
                                controlData={item.ControlData}
                                controlURL={item.ControlURL}
                            ></DynamicUserControl>
                        );
                    }
                    else {
                        let addbtn;
                        if (t.editing)
                            addbtn = (
                                <QBtn flat size="lg" onClick={(e) => this.browse(e, t, item)}>
                                    <QIcon name="mdi-plus" size="lg" />
                                </QBtn>
                            );

                        return (
                            <div>
                                <span><TranslationContainer context={this} value="No content defined"></TranslationContainer>: {item.id}</span>
                                <br />
                                {addbtn}
                            </div>
                        );
                    }
                },
            };

            window_body.push(
                <QTabPanel key={i} name={i} class="c-Dash__panel">
                    <ResponsiveDash
                        layout={t.layout}
                        editing={t.editing}
                        root={this.root}
                        onRemove={(item) => this.removeItem(t, item)}
                        configurable={(item) => this.isConfigurable(item)}
                        onConfigure={(item) => this.configureItem(t, item)}
                    >{scopedSlots}</ResponsiveDash>
                </QTabPanel>
            );
        }

        const showAddCard = this.dash_tabs[this.dashboard]?.editing;
        const showRemoveDashboard = this.dash_tabs[this.dashboard]?.ID && this.dash_tabs[this.dashboard]?.editing && !this.isTemplateComputed;
        var dashboardEditButtons = [
            showAddCard && (
                <QBtn key="add-card" outline color="primary" no-caps class="c-SentenceCaseButton" onClick={() => this.browse(this.dash_tabs[this.dashboard])}>
                    <TranslationContainer context={this} value="Add Card"></TranslationContainer>
                </QBtn>
            ),
            showRemoveDashboard && (
                <QBtn key="remove-dash" outline color="primary" no-caps class="c-SentenceCaseButton" onClick={() => this.deleteTab(this.dash_tabs[this.dashboard])}>
                    <TranslationContainer context={this} value="Remove Dashboard"></TranslationContainer>
                </QBtn>
            ),
        ].filter(Boolean)

        const header = this.getHeader(h);
        

        var dashboardEditTitleAndSave = [
            (
                <div style="display: flex; align-items: center;">
                    <QInput style="width: 250px;" dense outlined class="pt-1 pb-1" modelValue={this.dash_tabs[this.dashboard]?.Title} onUpdate:modelValue={(e) => this.dash_tabs[this.dashboard].Title = e} />
                </div>
            ),
            (
                <QBtn color="primary" no-caps class="c-SentenceCaseButton" onClick={() => this.saveTab(this.dash_tabs[this.dashboard])}>
                    <TranslationContainer context={this} value="Save"></TranslationContainer>
                </QBtn>
            ),
            (
                <QBtn color="secondary" no-caps class="c-SentenceCaseButton" onClick={() => this.cancelTab(this.dash_tabs[this.dashboard])}>
                    <TranslationContainer context={this} value="Cancel"></TranslationContainer>
                </QBtn>
            )

        ]

        const closeDashboardMenu = () => { 
            this.dashboardMenuOpen = false; 
        };
        const handleMenuItemClick = (index) => {
            this.dashboard = index; 
            this.System.LocalStorage(`Dashboard_${this.controlData.Name || 'undefined'}`, this.dash_tabs[this.dashboard].ID); 
            closeDashboardMenu(); 
        };
        var dashboardListItems = this.dash_tabs.map((d, index) => {
            return (
                <QItem key={index} active={this.dashboard == index} active-class="text-primary" clickable onClick={() => handleMenuItemClick(index)}>
                    <QItemSection avatar>
                        <QIcon name="mdi-view-dashboard" />
                    </QItemSection>
                    <QItemSection>
                        <QItemLabel><TranslationContainer context={this} value={d.Title}></TranslationContainer></QItemLabel>
                    </QItemSection>
                </QItem>
            )
        });

        if(this.isEditableComputed && !this.isTemplateComputed)
            dashboardListItems.push([
                (<QSeparator key="sep" />),
                (
                    <QItem key="add-tab" clickable onClick={() => {this.addTab(); closeDashboardMenu();}}>
                        <QItemSection avatar>
                            <QIcon name="mdi-plus" />
                        </QItemSection>
                        <QItemSection>
                            <QItemLabel>
                                <TranslationContainer context={this} value="New Dashboard"></TranslationContainer>
                            </QItemLabel>
                        </QItemSection>
                    </QItem>
                )
            ])

        return (
            <div style={this.style} class={{ "c-Dash": true, [`c-name-${this.name || "unnamed"}`]: true }}>
                { 
                    this.dash_tabs.length ?
                        <div class="c-Dash__body">
                            <div class="c-Dash__header mx-2">
                                <div>
                                    { 
                                        !this.dash_tabs[this.dashboard]?.editing ?
                                            <div>
                                                <QBtn color="primary" outline no-caps class="align-self-center q-mx-md q-my-sm">
                                                    {this.dash_tabs[this.dashboard]?.Title}
                                                    <QIcon
                                                        style={{ 'margin-left': '8px' }}
                                                        name="mdi-menu-down"
                                                    />
                                                    <QMenu 
                                                        anchor="bottom left" 
                                                        self="top left" 
                                                        modelValue={this.dashboardMenuOpen}
                                                        onUpdate:modelValue={(v) => this.dashboardMenuOpen = v}
                                                    >
                                                        <QList>
                                                            {dashboardListItems}
                                                        </QList>
                                                    </QMenu>
                                                </QBtn>
                                            </div>
                                        : null
                                    }
                                </div>
                                <div>
                                    {
                                        this.dash_tabs[this.dashboard]?.editing ? 
                                            <div style="display:flex; flex-direction: row; gap: 10px; align-items: center; justify-content:center; margin: 8px 0;">
                                                {dashboardEditTitleAndSave}
                                            </div> 
                                        : null
                                    }
                                </div>
                                <div style="padding-right: 10px; display:flex; flex-direction:row; gap: 5px; align-items:center; justify-content:flex-end">
                                    <div style="display:flex; flex-direction:row; gap: 5px; align-items:center">
                                        {
                                            this.dash_tabs[this.dashboard]?.editing ? 
                                            dashboardEditButtons 
                                            : header
                                        }
                                    </div>
                                </div>

                            </div>
                            <QCard class="c-Dash__card">
                                <QTabPanels modelValue={this.dashboard} onUpdate:modelValue={(v) => this.dashboard = v} class="c-Dash__tabs" animated>
                                    {window_body}
                                </QTabPanels>
                                <QDialog modelValue={this.pickervisible} onUpdate:modelValue={(v) => this.pickervisible = v} style={{ maxWidth: this.dialog_width + 'px' }}>
                                    {this.picker}
                                </QDialog>
                            </QCard>
                        </div>
                    : 
                        <div style="display: grid; grid-template-rows: 1fr 1fr 1fr; height: 100%">
                            <QIcon name="mdi-view-dashboard-edit-outline" style="font-size:20vh; top: 80px; color: #BDBDBD; justify-self: center" />
                            <div style="display:flex; flex-direction:column; justify-content:center; align-items:center; flex-grow:1; gap:10px;">
                                <div>
                                    <b style="font-size: 24px">
                                        <TranslationContainer context={this} value="Let's get started!"></TranslationContainer>
                                    </b>
                                </div>
                                <div>
                                    <TranslationContainer context={this} value="Visualize data in one place by creating dashboards that show what is happening across your contact center in real-time"></TranslationContainer>
                                </div>
                                <QBtn color="primary" no-caps class="c-SentenceCaseButton" onClick={() => this.addTab()}>
                                    <TranslationContainer context={this} value="CREATE DASHBOARD"></TranslationContainer>
                                </QBtn>
                            </div>
                        </div>
                }
            </div>
        );
    },
});